import React, { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import AllReport from "./AllReport";
import { FileText, TrendingUp, Download, Home, CreditCard, Building, Receipt, Search, FileBarChart,ChevronDown,Eye,EyeOff,Grid, List, Layers,
} from "lucide-react";

const Report = () => {
  const REPORT_ITEMS = [
    {
      id: "all",
      label: "ALL REPORTS",
      icon: <FileBarChart size={18} />,
      count: 24,
      description: "View All",
      color: "#0d6efd",
    },
    {
      id: "passport",
      label: "PASSPORT NOC REPORTS",
      icon: <FileText size={18} />,
      count: 8,
      description: "Passport verification and NOC reports",
      color: "#10b981",
    },
    {
      id: "oas",
      label: "OAS NOC REPORTS",
      icon: <Building size={18} />,
      count: 6,
      description: "Outsourced agency services reports",
      color: "#8b5cf6",
    },
    {
      id: "renovation",
      label: "RENOVATION REPORTS",
      icon: <Home size={18} />,
      count: 12,
      description: "Society renovation and maintenance reports",
      color: "#f59e0b",
    },
    {
      id: "sales",
      label: "SALES REPORTS",
      icon: <TrendingUp size={18} />,
      count: 15,
      description: "Property sales and transfer reports",
      color: "#ef4444",
    },
    {
      id: "credit",
      label: "CREDIT REPORTS",
      icon: <CreditCard size={18} />,
      count: 9,
      description: "Credit transactions and income reports",
      color: "#06b6d4",
    },
    {
      id: "debit",
      label: "DEBIT REPORTS",
      icon: <Receipt size={18} />,
      count: 11,
      description: "Debit transactions and expense reports",
      color: "#8b5cf6",
    },
  ];

  const [selectedReport, setSelectedReport] = useState(REPORT_ITEMS[0]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [dateRange, setDateRange] = useState("last30");
  const [searchQuery, setSearchQuery] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [viewMode, setViewMode] = useState("detailed"); 
  const [autoRefresh, setAutoRefresh] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const getSelectedReportStats = () => {
    if (selectedReport.id === "all") {
      return {
        total: 85,
        generated: 24,
        pending: 3,
        today: 2,
      };
    }
    return {
      total: selectedReport.count,
      generated: selectedReport.count - 2,
      pending: 2,
      today: 1,
    };
  };

  const stats = getSelectedReportStats();

  const handleReportSelect = (report) => {
    setSelectedReport(report);
    setShowDropdown(false);
  };

  const toggleViewMode = () => {
    setViewMode(viewMode === "detailed" ? "compact" : "detailed");
  };

  const handleExportReport = () => {
    alert(`Exporting ${selectedReport.label} report...`);
  };

  return (
    <div className="app-container">
      <style>
        {`
        .app-container {
          height: 100vh;
          overflow: hidden;
        }

        .main-layout {
          height: calc(100vh - 64px);
          overflow: hidden;
        }

        .content-area {
          height: 100%;
          overflow-y: auto;
          padding-bottom: 40px;
          background: #f8fafc;
        }

        .report-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 24px;
        }

        /* Header Section */
        .report-header {
          margin-bottom: 32px;
        }

        .report-stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 16px;
          margin-top: 24px;
        }

        .stat-card {
          background: white;
          border-radius: 12px;
          padding: 20px;
          border: 1px solid #e2e8f0;
          display: flex;
          align-items: center;
          gap: 16px;
          transition: all 0.2s;
          cursor: pointer;
        }

        .stat-card:hover {
          border-color: #cbd5e1;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          transform: translateY(-2px);
        }

        .stat-icon {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .stat-icon.total {
          background: #e0f2fe;
          color: #0d6efd;
        }

        .stat-icon.generated {
          background: #dcfce7;
          color: #10b981;
        }

        .stat-icon.pending {
          background: #fef3c7;
          color: #f59e0b;
        }

        .stat-icon.today {
          background: #f3e8ff;
          color: #8b5cf6;
        }

        .stat-content {
          flex: 1;
        }

        .stat-number {
          font-size: 24px;
          font-weight: 700;
          color: #1e293b;
          line-height: 1;
          margin-bottom: 4px;
        }

        .stat-label {
          font-size: 13px;
          color: #64748b;
          font-weight: 500;
        }

        /* Main Report Container */
        .report-main-container {
          background: white;
          border-radius: 16px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
          overflow: hidden;
        }

        /* Report Header */
        .report-header-main {
          padding: 24px;
          border-bottom: 1px solid #e2e8f0;
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          flex-wrap: wrap;
          gap: 16px;
        }

        .report-header-left {
          flex: 1;
          min-width: 300px;
        }

        /* Report Type Dropdown */
        .report-type-dropdown {
          position: relative;
          margin-bottom: 16px;
        }

        .dropdown-toggle {
          width: 100%;
          padding: 12px 16px;
          background: white;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          transition: all 0.2s;
        }

        .dropdown-toggle:hover {
          border-color: #0d6efd;
        }

        .dropdown-toggle.active {
          border-color: #0d6efd;
          box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
        }

        .selected-report-content {
          display: flex;
          align-items: center;
          gap: 12px;
          flex: 1;
        }

        .selected-report-icon {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
        }

        .selected-report-info {
          flex: 1;
        }

        .selected-report-label {
          font-size: 16px;
          font-weight: 600;
          color: #1e293b;
          display: block;
          margin-bottom: 4px;
        }

        .selected-report-description {
          font-size: 13px;
          color: #64748b;
          display: block;
        }

        .dropdown-arrow {
          color: #64748b;
          transition: transform 0.2s;
        }

        .dropdown-toggle.active .dropdown-arrow {
          transform: rotate(180deg);
          color: #0d6efd;
        }

        .dropdown-menu {
          position: absolute;
          top: calc(100% + 8px);
          left: 0;
          right: 0;
          background: white;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
          z-index: 1000;
          max-height: 400px;
          overflow-y: auto;
          display: none;
        }

        .dropdown-menu.show {
          display: block;
        }

        .dropdown-item {
          padding: 12px 16px;
          display: flex;
          align-items: center;
          gap: 12px;
          cursor: pointer;
          transition: all 0.2s;
          border-bottom: 1px solid #f1f5f9;
        }

        .dropdown-item:last-child {
          border-bottom: none;
        }

        .dropdown-item:hover {
          background: #f8fafc;
        }

        .dropdown-item.active {
          background: #f0f9ff;
          border-left: 3px solid #0d6efd;
        }

        .dropdown-item-icon {
          width: 32px;
          height: 32px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .dropdown-item-info {
          flex: 1;
        }

        .dropdown-item-label {
          font-size: 14px;
          font-weight: 600;
          color: #1e293b;
          display: block;
          margin-bottom: 2px;
        }

        .dropdown-item-description {
          font-size: 12px;
          color: #64748b;
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .dropdown-item-count {
          background: #e2e8f0;
          color: #475569;
          font-size: 11px;
          font-weight: 600;
          padding: 2px 8px;
          border-radius: 12px;
          margin-left: 8px;
        }

        .dropdown-item.active .dropdown-item-count {
          background: #0d6efd;
          color: white;
        }

        .report-description {
          font-size: 14px;
          color: #64748b;
          line-height: 1.6;
          padding: 12px 16px;
          background: white;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
        }

        /* Report Controls */
        .report-controls-container {
          display: flex;
          flex-direction: column;
          gap: 16px;
          min-width: 300px;
        }

        .controls-row {
          display: flex;
          gap: 12px;
          align-items: center;
          flex-wrap: wrap;
        }

        .search-bar {
          flex: 1;
          min-width: 200px;
          position: relative;
        }

        .search-input {
          width: 100%;
          padding: 10px 16px 10px 40px;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          font-size: 14px;
          background: white;
          transition: all 0.2s;
        }

        .search-input:focus {
          outline: none;
          border-color: #0d6efd;
          box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
        }

        .search-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
        }

        .date-selector {
          padding: 10px 16px;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          background: white;
          color: #475569;
          font-size: 14px;
          cursor: pointer;
          min-width: 140px;
        }

        .action-buttons {
          display: flex;
          gap: 8px;
        }

        .icon-btn {
          width: 40px;
          height: 40px;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
          background: white;
          color: #475569;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s;
        }

        .icon-btn:hover {
          background: #f8fafc;
          border-color: #cbd5e0;
        }

        .icon-btn.active {
          background: #0d6efd;
          border-color: #0d6efd;
          color: white;
        }

        .primary-btn {
          padding: 10px 20px;
          background: linear-gradient(135deg, #10b981 0%, #059669 100%);
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .primary-btn:hover {
          opacity: 0.9;
          transform: translateY(-1px);
        }

        /* Quick Stats */
        .quick-stats {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 12px;
          margin-top: 16px;
          padding: 16px;
          background: white;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
        }

        .quick-stat-item {
          text-align: center;
          padding: 12px;
          border-radius: 8px;
          background: #f8fafc;
          transition: all 0.2s;
        }

        .quick-stat-item:hover {
          background: #f1f5f9;
          transform: translateY(-1px);
        }

        .quick-stat-value {
          font-size: 20px;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 4px;
        }

        .quick-stat-label {
          font-size: 12px;
          color: #64748b;
          font-weight: 500;
        }

        /* Report Content */
        .report-content {
          padding: 24px;
        }

        .report-content-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 24px;
          padding-bottom: 16px;
          border-bottom: 1px solid #f1f5f9;
        }

        .report-content-title {
          font-size: 18px;
          font-weight: 600;
          color: #1e293b;
          margin: 0;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .report-actions {
          display: flex;
          gap: 8px;
        }

        .report-action-btn {
          padding: 8px 16px;
          border-radius: 6px;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 6px;
          border: 1px solid transparent;
        }

        .report-action-btn.download {
          background: #dbeafe;
          border-color: #93c5fd;
          color: #1d4ed8;
        }

        .report-action-btn.download:hover {
          background: #93c5fd;
        }

        .report-action-btn.print {
          background: #f1f5f9;
          border-color: #e2e8f0;
          color: #475569;
        }

        .report-action-btn.print:hover {
          background: #e2e8f0;
        }

        .report-action-btn.share {
          background: #f3e8ff;
          border-color: #d8b4fe;
          color: #7c3aed;
        }

        .report-action-btn.share:hover {
          background: #d8b4fe;
        }

        /* View Toggle */
        .view-toggle {
          display: flex;
          background: #f1f5f9;
          border-radius: 8px;
          padding: 2px;
          margin-left: 12px;
        }

        .view-toggle-btn {
          padding: 6px 12px;
          border-radius: 6px;
          border: none;
          background: transparent;
          color: #64748b;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 4px;
        }

        .view-toggle-btn.active {
          background: white;
          color: #0d6efd;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        /* Auto Refresh Toggle */
        .auto-refresh-toggle {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-left: 12px;
          padding: 6px 12px;
          background: #f8fafc;
          border-radius: 6px;
          border: 1px solid #e2e8f0;
          font-size: 12px;
          color: #475569;
        }

        .auto-refresh-toggle label {
          display: flex;
          align-items: center;
          gap: 4px;
          cursor: pointer;
        }

        /* Report Content Area */
        .report-data-area {
          min-height: 400px;
        }

        /* Empty State */
        .empty-report-state {
          padding: 60px 24px;
          text-align: center;
          color: #64748b;
          background: #f8fafc;
          border-radius: 12px;
          border: 2px dashed #e2e8f0;
        }

        .empty-state-icon {
          color: #cbd5e0;
          margin-bottom: 16px;
        }

        .empty-report-state h3 {
          font-size: 18px;
          font-weight: 600;
          margin: 0 0 8px 0;
          color: #475569;
        }

        .empty-report-state p {
          font-size: 14px;
          margin: 0 0 20px 0;
        }

        /* Loading State */
        .loading-state {
          padding: 40px;
          text-align: center;
          color: #64748b;
        }

        .spin-animation {
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .report-header-main {
            flex-direction: column;
          }
          
          .report-controls-container {
            width: 100%;
          }
        }

        @media (max-width: 768px) {
          .report-container {
            padding: 16px;
          }

          .report-stats-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .controls-row {
            flex-direction: column;
          }

          .search-bar,
          .date-selector {
            width: 100%;
          }

          .action-buttons {
            width: 100%;
            justify-content: center;
          }

          .report-content-header {
            flex-direction: column;
            gap: 12px;
            align-items: flex-start;
          }

          .report-actions {
            width: 100%;
            justify-content: center;
          }

          .quick-stats {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 480px) {
          .report-stats-grid {
            grid-template-columns: 1fr;
          }

          .quick-stats {
            grid-template-columns: 1fr;
          }

          .primary-btn span {
            display: none;
          }

          .primary-btn {
            padding: 10px;
          }
        }

        /* Report Summary */
        .report-summary {
          margin-bottom: 24px;
          padding: 20px;
          background: #f8fafc;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
        }

        .summary-title {
          font-size: 16px;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .summary-content {
          font-size: 14px;
          color: #64748b;
          line-height: 1.6;
        }
        `}
      </style>

      <Header toggleSidebar={toggleSidebar} />
      <div className="main-layout">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />
        <main className="content-area">
          <SubHeader />

          <div className="report-container">
            <div className="report-main-container">
              <div className="report-header-main">
                <div className="report-header-left">
                  <div className="report-type-dropdown">
                    <div
                      className={`dropdown-toggle ${showDropdown ? "active" : ""}`}
                      onClick={() => setShowDropdown(!showDropdown)}
                    >
                      <div className="selected-report-content">
                        <div
                          className="selected-report-icon"
                          style={{
                            background: `linear-gradient(135deg, ${selectedReport.color}99, ${selectedReport.color})`,
                          }}
                        >
                          {selectedReport.icon}
                        </div>
                        <div className="selected-report-info">
                          <span className="selected-report-label">
                            {selectedReport.label}
                          </span>
                          <span className="selected-report-description">
                            {selectedReport.description}
                          </span>
                        </div>
                        <ChevronDown size={20} className="dropdown-arrow" />
                      </div>
                    </div>
                    <div
                      className={`dropdown-menu ${showDropdown ? "show" : ""}`}
                    >
                      {REPORT_ITEMS.map((item) => (
                        <div
                          key={item.id}
                          className={`dropdown-item ${selectedReport.id === item.id ? "active" : ""}`}
                          onClick={() => handleReportSelect(item)}
                        >
                          <div
                            className="dropdown-item-icon"
                            style={{ color: item.color }}
                          >
                            {item.icon}
                          </div>
                          <div className="dropdown-item-info">
                            <span className="dropdown-item-label">
                              {item.label}
                              <span className="dropdown-item-count">
                                {item.count}
                              </span>
                            </span>
                            <span className="dropdown-item-description">
                              {item.description}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="report-controls-container">
                  <div className="controls-row">
                    <div className="search-bar">
                      <Search size={16} className="search-icon" />
                      <input
                        type="text"
                        placeholder="Search within reports..."
                        className="search-input"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>

                    <select
                      className="date-selector"
                      value={dateRange}
                      onChange={(e) => setDateRange(e.target.value)}
                    >
                      <option value="today">Today</option>
                      <option value="yesterday">Yesterday</option>
                      <option value="last7">Last 7 days</option>
                      <option value="last30">Last 30 days</option>
                      <option value="last90">Last 90 days</option>
                      <option value="custom">Custom range</option>
                    </select>
                  </div>

                  <div className="controls-row">
                    <div className="action-buttons">
                      <button
                        className={`icon-btn ${viewMode === "compact" ? "active" : ""}`}
                        onClick={toggleViewMode}
                        title={
                          viewMode === "detailed"
                            ? "Switch to compact view"
                            : "Switch to detailed view"
                        }
                      >
                        {viewMode === "detailed" ? (
                          <List size={18} />
                        ) : (
                          <Grid size={18} />
                        )}
                      </button>
                    
                      <button
                        className={`icon-btn ${autoRefresh ? "active" : ""}`}
                        onClick={() => setAutoRefresh(!autoRefresh)}
                        title="Toggle auto refresh"
                      >
                        {autoRefresh ? <Eye size={18} /> : <EyeOff size={18} />}
                      </button>
                      <button
                        className="primary-btn"
                        onClick={handleExportReport}
                      >
                        <Download size={18} />
                        <span>Export Report</span>
                      </button>
                    </div>

                    <div className="view-toggle">
                      <button
                        className={`view-toggle-btn ${viewMode === "detailed" ? "active" : ""}`}
                        onClick={() => setViewMode("detailed")}
                      >
                        <Grid size={14} />
                        Detailed
                      </button>
                      <button
                        className={`view-toggle-btn ${viewMode === "compact" ? "active" : ""}`}
                        onClick={() => setViewMode("compact")}
                      >
                        <List size={14} />
                        Compact
                      </button>
                    </div>

                    <div className="auto-refresh-toggle">
                      <label>
                        <input
                          type="checkbox"
                          checked={autoRefresh}
                          onChange={(e) => setAutoRefresh(e.target.checked)}
                          style={{ marginRight: "4px" }}
                        />
                        Auto Refresh
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {/* Report Content */}
              <div className="report-content">
                <div className="report-content-header">
                 <h3 className="report-content-title flex items-center gap-2 text-blue-600">
  <Layers size={20} />
  Report Details - {selectedReport.label}
</h3>
               
                </div>

               

                {/* Actual Report Component */}
                <div className="report-data-area">
                  <AllReport
                    selectedReport={selectedReport.label}
                    viewMode={viewMode}
                  />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Report;
